<template>
  <div>
    <div class="animated fadeIn">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header">
              <span class="title_head">Search Brand</span>
            </div>
            <b-collapse id="collapse1" visible>
              <b-card-body>
                <div v-if="errorMessage.message != ''" class="alert alert-success col-sm-12" data-auto-dismiss="2000">
                  {{errorMessage.message}}
                </div>
                <b-row>
                  <b-col md="5">
                    <b-form-group>
                      <label for="name"> Brand Name:</label>
                      <b-form-input type="text"  placeholder="Enter Brand Name" v-model="brandData.brandname12" name="brand_name"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="5">
                    <b-form-group>
                      <label for="name">Brand Description</label>
                      <b-form-input type="text" placeholder="Enter Brand Description" v-model="brandData.desc12"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="2"> 
                    <button type="button" v-if="brand_view === true" class="btn btn-pill btn-primary serach_bttn" @click.prevent="getTotals" style="margin-top: 24px;">
                    <i class="fa fa-search"></i> Search</button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>

    <div class="animated fadeIn">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header">
              <span class="title_head">Brand List Table <span>
                <button type="button" class="btn btn-sm btn-primary label_bttn" v-if="brand_rights === true" variant="secondary" @click.prevent="addbrand()"><i class="fa fa-plus"></i> Add Brand</button></span> 
              </span>
            </div>
            <div class="card-body">
              <vue-snotify></vue-snotify>
              <div class="table-responsive-sm">
                <vue-good-table 
                :columns="columns" 
                :rows="rows" 
                mode="remote"
                ref="my-table"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
                :totalRows="totalRecords"
                styleClass="vgt-table striped bordered table-sm condensed" :paginationOptions="{enabled: true,perPage:5 }">
                  <template slot="table-row" slot-scope="props" >
                    <span v-if="props.column.field == 'action'">

                      <span v-if="brand_rights === true">
                        <span v-if="props.row.company_id !== 'I2OCGLB'">
                        <i class="fa fa-edit" @click.prevent="editpro(props.row)"></i>
                        <i class="fa fa-trash" @click.prevent="deletebrand(props.row)"></i>
                      </span>
                      <span v-else>
                        <span v-if="is_admin === true">
                        <i class="fa fa-edit" @click.prevent="editpro(props.row)"></i>
                        <i class="fa fa-trash" @click.prevent="deletebrand(props.row)"></i>
                      </span>
                      <span v-else>
                       <i class="fa fa-edit" @click.prevent="viewbrand(props.row)" style="color:lightblue !important;"></i>
                        <i class="fa fa-trash" style="color:grey !important;"></i>
                      </span>
                      </span>
                      </span>
                      <span v-else>
                        <i class="fa fa-edit" style="color:grey !important;"></i>
                        <i class="fa fa-trash" style="color:grey !important;"></i>
                      </span>
                    </span>
                    <span v-else>
                      {{props.formattedRow[props.column.field]}}
                    </span>
                  </template>
                  <div slot="emptystate" style="text-align:center;" v-if="loading">
                    <i class="fa fa-spinner fa-spin"></i>&nbsp;Loading
                  </div>
                </vue-good-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal title="Add Brand" no-close-on-esc no-close-on-backdrop size="lg" class="modal-info" hide-footer v-model="largeModal" @ok="largeModal = false">
      <b-row>
        <b-col sm="4">
          <b-form-group>
            <label for="name">Add Brand:<span style="color:red"> *</span></label>
            <b-form-input ref="txtbrandname" v-on:keyup.native="onComplete('bname')" type="text" id="" placeholder="Enter Brand Name" :class="{'is-invalid':hasErrors.brandnm}" v-model="brandData.brandname" name="" @blur.native="chkBrandExist()"></b-form-input>
            <small  class="form-text text-muted" v-if="hasErrors.brandnm" ><strong style="color: red;">{{hasErrors.brandnm}}</strong></small>
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group>
            <label for="name">Brand Description</label>
            <b-form-input v-on:keyup.native="onComplete('bdesc')" type="text" placeholder="Enter Brand Description" :class="{'is-invalid':hasErrors.branddsc}" v-model="brandData.desc"></b-form-input>
            <small  class="form-text text-muted" v-if="hasErrors.branddsc" ><strong style="color: red;">{{hasErrors.branddsc}}</strong></small>
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group>
            <label for="name">Brand Logo :</label>
            <input :class="{'is-invalid':hasErrors.brandlogo}" type="file" id="image" name="image" accept="image/*" class="form-control filesize">
            <small  class="form-text text-muted" v-if="hasErrors.brandlogo"><strong style="color: red;">{{errorMessage.brandlogo}}</strong></small>
          </b-form-group>
        </b-col>
      </b-row>
      <div class="card-footer modal_footer">
        <b-row>
          <b-col sm="12">
            <b-button-group>
              <b-button class="d-sm-down-none btn-sm" @click.prevent="brandPost()" variant="primary"><i class="fa fa-dot-circle-o"></i> Save</b-button>
            </b-button-group>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <b-modal title="Edit Brand" no-close-on-esc no-close-on-backdrop size="lg" class="modal-info" hide-footer v-model="warningModal"  @ok="warningModal1 = true" ok-variant="warning">
      <b-collapse id="collapse1" visible>
        <b-card-body>
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <label for="name">Brand Name <span class="star">*</span></label>
                <b-form-input type="text" placeholder="Enter Brand Name" :class="{'is-invalid':hasErrors.brandnm1}" v-model="brandData.brandname1" name="brand_name"
                v-on:keyup.native="onComplete('editbname')"
                ></b-form-input>
                <small  class="form-text text-muted" v-if="hasErrors.brandnm1" ><strong style="color: red;">{{hasErrors.brandnm1}}</strong></small>
              </b-form-group>
              <b-form-group>
                <label for="name">Brand Description <span class="star">*</span></label>
                <b-form-input type="text" placeholder="Enter Brand Description" :class="{'is-invalid':hasErrors.branddsc1}" v-model="brandData.desc1" v-on:keyup.native="onComplete('editbdesc')"></b-form-input>
                <small  class="form-text text-muted" v-if="hasErrors.branddsc1" ><strong style="color: red;">{{hasErrors.branddsc1}}</strong></small>
              </b-form-group>
              <b-form-group>
                <label for="name">Brand Logo :</label>
                <input :class="{'is-invalid':hasErrors.brandlogo1}" type="file" id="image1" name="image1" accept="image/*" class="form-control filesize">
                <small  class="form-text text-muted" v-if="hasErrors.brandlogo1"><strong style="color: red;">{{errorMessage.brandlogo1}}</strong></small>
                <p v-if="brandData.image1!=null">Click to view uploaded Image/File <a :href="brandData.image1_href" target="blank"><i class="fa fa-file-image-o" style="color: skyblue; cursor: pointer;"></i></a></p>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <span v-if="brandData.image1!=null"><img :src="brandData.image1_href" class="img-thumbnail" width="250px" height="250px"></span>
            </b-col>
          </b-row>
        </b-card-body>
      </b-collapse>
      <div class="modal_footer card-footer">
        <b-row>
          <b-col sm="4"> 
            <button type="submit" class="btn btn-sm btn-primary" @click.prevent="submodel"><i class="fa fa-dot-circle-o"></i> Save</button>
          </b-col>
        </b-row>
      </div>
    </b-modal>


    <b-modal title="View Brand" no-close-on-esc no-close-on-backdrop size="lg" class="modal-info" hide-footer v-model="warningModal2"  @ok="warningModal2 = true" ok-variant="warning">
      <b-collapse id="collapse1" visible>
        <b-card-body>
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <label for="name">Brand Name</label>
                <b-form-input type="text" placeholder="Enter Brand Name" :class="{'is-invalid':hasErrors.brandnm1}" disabled v-model="brandData.brandname1" name="brand_name"
                v-on:keyup.native="onComplete('editbname')"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <label for="name">Brand Description</label>
                <b-form-input type="text" disabled placeholder="Enter Brand Description" :class="{'is-invalid':hasErrors.branddsc1}" v-model="brandData.desc1" v-on:keyup.native="onComplete('editbdesc')"></b-form-input>
              </b-form-group>
              <b-form-group>
                <label for="name">Brand Logo :</label>
                <p v-if="brandData.image1!=null">Click to view uploaded Image/File <a :href="brandData.image1_href" target="blank"><i class="fa fa-file-image-o" style="color: skyblue; cursor: pointer;"></i></a></p>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <span v-if="brandData.image1!=null"><img :src="brandData.image1_href" class="img-thumbnail" width="250px" height="250px"></span>
            </b-col>
          </b-row>
        </b-card-body>
      </b-collapse>
    </b-modal>
    <Spinner v-if="loading"></Spinner>
  </div>
</template>

<script>

  var idup='';
 import Spinner from '../../spinner.vue'
       export default {
           components: {
     Spinner
   },
        data(){
            return{
                // pg_view:false,
                // pg_rights:false,
                is_admin:false,
                shpfrst_time:false,
                tfrst_time:false,
                access_token:null,
                submit_edi: 0,
                submit_true:0, 
                largeModal:false,
                warningModal:false,
                warningModal2:false,
                loading:false,
                totalRecords: 0,
                serverParams: {
                columnFilters: {
                           },
                sort: {},
                page: 1, 
                perPage: 5
              },
                brandData:{
                    brandname:'',
                    desc:'',
                    brandname1:'',
                    brandname12:'',
                    desc12:'',
                    desc1:'',
                    message:'',
                    image1:null,
                    image1_href:''

                },
                allowableTypes: ['image/jpg', 'image/jpeg', 'image/png'],
                maximumSize: 500000,
                hasErrors:{
                    brandname:false,
                    message: false,
                    branddsc1:false,
                    brandnm:false,
                    branddsc:false,
                    brandlogo:false,
                    brandnm1:false,
                    brandnm12:false,
                    branddsc12:false,
                    brandlogo1:false,

                },
                errorMessage:{
                    brandname:null,
                    message:'',
                    brandlogo:null,
                    brandlogo1:null
                },
                columns: [
                {
                  label: 'Brand Name',
                  field: 'brand_name',
                  width: '40% !important'
                },
                {
                  label: 'Brand Description',
                  field: 'brand_desc',
                  width: '50% !important',
                  html: false
                },
                {
                  label: 'Action',
                  field: 'action',
                  width: '10% !important'
                },
                
      ],
      rows:[],
            }
        },
        methods:{
          updateParams(newProps) {
          this.serverParams = Object.assign({}, this.serverParams, newProps);
              },
            
          onPageChange(params) { 
                   this.updateParams({page: params.currentPage});
                   this.getTotals();
            },

          onPerPageChange(params) {
              this.updateParams({perPage: params.currentPerPage,page:1});
              this.getTotals();
            },

          onSortChange(params) {
              this.updateParams({
                sort: {
                  type: params.sortType,
                  field: this.columns[params.columnIndex].field,
                },page:1
              });
              this.getTotals();
            },
            
          onColumnFilter(params) {
              this.updateParams(params);
              this.getTotals();
            },
          shopuser(val){
            if(val === 'comp'){
              if(this.shpfrst_time === false){
                this.shpfrst_time = true
              }
              else{
                return
              }
            }
            var _this=this
            this.$http.get('/api/shopusers').then(function(response){

            }).catch(function(error){
              if (error.response.status === 401) {
                localStorage.clear();
                _this.$store.commit('SET_AUTH_USER', null)
                _this.$router.push('/');
              }
              if(error.response.data.error.message === "Cannot read property 'cmpname' of null"){
                localStorage.clear();
                _this.$store.commit('SET_AUTH_USER', null)
                _this.$router.push('/');
              }
            })
          },
          addbrand(){
            this.hasErrors.brandnm=false
            this.hasErrors.branddsc=false
            this.hasErrors.brandlogo=false
            this.largeModal = true
          },

          editpro(brandlistid){
            this.hasErrors.brandnm1=false
            this.hasErrors.branddsc1=false
            this.warningModal = true
            var _this=this
            this.brandData.desc1=brandlistid.brand_desc
            this.brandData.brandname1=brandlistid.brand_name
            idup=brandlistid.brand_id
            this.brandData.image1 = brandlistid.brand_logo
            this.brandData.image1_href = this.$http.defaults.baseURL+'/api/containers/pics/download/'+brandlistid.brand_logo+this.access_token
          },

          viewbrand(brandlistid){
            this.warningModal2 = true
            this.brandData.desc1=brandlistid.brand_desc
            this.brandData.brandname1=brandlistid.brand_name
            this.brandData.image1 = brandlistid.brand_logo
            this.brandData.image1_href = this.$http.defaults.baseURL+'/api/containers/pics/download/'+brandlistid.brand_logo+this.access_token
          },


      image1(callback){
      var _this = this
      const image1 = document.querySelector('#image1');
      if(this.brandData.image1!=null){
        if(image1.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image1.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
          .then(function (response) {
            _this.$http.delete('/api/containers/pics/files/'+_this.brandData.image1)
            return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return this.brandData.image1
        }
      }else{
        if(image1.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image1.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
            .then(function (response) {
              return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return null;
        }        
      } 
          },
          deletebrand(brandid){
            var r = confirm("Are you sure you want to delete?");
            if (r == true) {
              this.loading=true
              var _this=this
              var _vm = this.errorMessage
              var id =brandid.id;
              this.$http.delete('/api/brands/'+id).then(function (response) {
                _this.loading=false
                _vm.message = "Brand Deleted Successfully"
                setTimeout(function(){ _vm.message='';}, 2000);
                _this.getTotals();
              })
              .catch(function (error) {
                _this.loading=false
                console.log(error);
              });
            }
          },


          test(){
            const fileInput = document.querySelector('#image');
            var formData = new FormData();
            formData.append('image', fileInput.files[0]);
            return this.$http.post('/api/containers/pics/upload', formData)
              .then(function (response) {
                return response.data.result.files.image[0].name;
            })
            .catch(function (error) {
              console.log(error);
            });
          },
          
      chkBrandExist(){
        var _this = this
        this.brandData.brandname = this.brandData.brandname.trim()
        if(this.brandData.brandname != ''){
          this.$http.get('/api/brands/chk_brand_exist?filter[where][brand_name]='+this.brandData.brandname).then(function (response){
            if(response.data.length > 0){
              _this.brandData.brandname = ''
              _this.hasErrors.brandnm = 'Brand name already exist'
              _this.$refs['txtbrandname'].focus()
            }
            else{
              _this.hasErrors.brandnm = false
            }
          })
          .catch(function(error){
            _this.hasErrors.brandnm = false
          });
        }
        else{
           _this.hasErrors.brandnm = false
        }
      },

      brandPost(){ 
        var _this = this
        this.submit_true=0;
        this.onComplete('check')

        var formData = new FormData();
        _this.hasErrors.brandlogo=false;
        const fileInput = document.querySelector('#image');

        if(fileInput.files[0]!=undefined){
          if(fileInput.files[0].size>this.maximumSize){
            this.hasErrors.brandlogo=true;
            this.errorMessage.brandlogo="Image Size Cannot Be Greater Than 500kb"
            this.submit_true=1
          }
          if( this.allowableTypes.indexOf(fileInput.files[0].type.toLowerCase())=== -1){
            this.hasErrors.brandlogo=true;
            this.errorMessage.brandlogo="Invalid Image Type"
            this.submit_true=1
          }
        }

    if (this.submit_true==0){
      this.loading=true
       this.largeModal=false;
    
    if(fileInput.files[0]!=undefined){
       this.test().then((user)=>{
           _this.submitbrandvalue(_this,user)
      })
    }else{
      var user=null;
      _this.submitbrandvalue(_this,user)
    }

    
             }
            },
            submitbrandvalue(_this,user){
                if(user!=null){
                  var has_logo = 1
              }else{
                var has_logo = 0
               }
                      let res = {
                          brand_name: this.brandData.brandname.trim(),
                          brand_desc:this.brandData.desc,
                          brand_logo:user,
                          has_logo:has_logo,
                        }

                this.$http.post('/api/brands', res)
                .then(function (response) {
              
              
               if(response.status==200){
                _this.message = true
                 _this.message = "Brand Added Successfully"
                 setTimeout(function(){ _this.message='';}, 2000);
                 _this.loading=false;
                 _this.getTotals();
                  _this.reset();
                
               }else{
                console.log('error')
               }
            
                })
                  .catch(function (error) {
                    _this.loading=false
                    console.log(error)
                  });

            },

        submodel(){
        var _this = this
        this.submit_edi=0;
        this.onComplete('check')
        this.hasErrors.brandlogo1=false;
        this.errorMessage.brandlogo1='';
        const fileInput1 = document.querySelector('#image1');
        //var has_logo1 = 0
        if(fileInput1.files[0]!=undefined){
          if(fileInput1.files[0].size>this.maximumSize){
            this.hasErrors.brandlogo1=true;
            this.errorMessage.brandlogo1="Image Size Cannot Be Greater Than 500kb"
            this.submit_edi=1
          }
          if( this.allowableTypes.indexOf(fileInput1.files[0].type.toLowerCase())=== -1){
            this.hasErrors.brandlogo1=true;
            this.errorMessage.brandlogo1="Invalid Image Type"
            this.submit_edi=1
          }

        }
          if (this.submit_edi==0){
              _this.loading=true
              _this.warningModal=false;
            
             Promise.all([this.image1()]).then(user=>{
              if(user!=null){
                  var has_logo = 1
              }else{
                var has_logo = 0
               }
             
              let res = {
                brand_name: this.brandData.brandname1.trim(),
                brand_desc:this.brandData.desc1.trim(),
                brand_logo:user,
                has_logo:has_logo,
              }
              this.$http.post('/api/brands/update?where[id]='+idup,res) .then(function (response){

                if(response.status===200){
                  _this.message = true
                  _this.message = "Brand Updated Successfully"
                  setTimeout(function(){ _this.message='';}, 2000);
                  _this.loading=false;
                  _this.reset();
                  _this.getTotals();
                }else{
                  console.log('error')
                }
              })
              .catch(function (error) {
                _this.loading=false
                console.log(error)
              });

            });
          }
          },
             
            reset(){
              var _this =this
              _this.brandData.brandname= ''
              _this.brandData.desc= ''
              const input = document.querySelector('#image');
              input.type = 'text'
              input.type = 'file'              
            },
          getTotals(val){    
            if(val === 'comp'){
                if(this.tfrst_time === false){
                  this.tfrst_time = true
                }
                else{
                  return
                }
              }
            var _this=this
            this.brandData.brandname12 = this.brandData.brandname12.trim()
            this.brandData.desc12 = this.brandData.desc12.trim()
            let filteParam = {};
            filteParam.page = this.serverParams.page;
            filteParam.perPage = this.serverParams.perPage;
            filteParam.sort = this.serverParams.sort;
            var data=[];
            this.rows=[];
            if(this.brandData.brandname12!=''){
              data=data+"&filter[where][brand_name][ilike]=%"+this.brandData.brandname12+"%"
            }
            if(this.brandData.desc12!=''){
              data= data+"&filter[where][brand_desc][ilike]=%"+this.brandData.desc12+"%"
          
            }
            this.loading = true
            this.$http.get('/api/brands/showBrands?params='+JSON.stringify(filteParam)+data)
                    .then(function(response){
                      _this.totalRecords = response.data[0].totalRecords;
                      response.data.shift()
                      if(response.data != undefined)
                      _this.rows=  response.data;
                      _this.loading = false
                      }).catch(function(error){
                  console.log(error)
              })
            },

            onComplete(value){
              this.hasErrors.brandnm=''; 
              this.hasErrors.branddsc='';
              this.hasErrors.brandnm1='';
              this.hasErrors.branddsc1='';           
              this.brandData.brandname = this.brandData.brandname
              this.brandData.desc = this.brandData.desc
              if(value === 'bname' || value === 'check')
            {
                if(this.brandData.brandname=='' || this.brandData.brandname==''){
                  this.hasErrors.brandnm ='Required';
                  this.submit_true=1;
                }

                else if(this.brandData.brandname.length > 100){
                  this.hasErrors.brandnm ='Maximum 100 characters';
                  this.submit_true=1;
                }

                else if(this.brandData.brandname.length < 2){
                  this.hasErrors.brandnm  ='Minimum 2 characters';
                  this.submit_true=1;
                }else{  this.hasErrors.brandnm  ='';}
            }

          if(value === 'bdesc' || value === 'check')
            {
                if(this.brandData.desc.length > 500){
                  this.hasErrors.branddsc ='Maximum 500 characters';
                  this.submit_true=1;
                }

                else if(this.brandData.desc.length < 2){
                  this.hasErrors.branddsc  ='Minimum 2 characters';
                  this.submit_true=1;
                }else{  this.hasErrors.branddsc  ='';}
            }

            // edit oncomplete
            this.brandData.brandname1 = this.brandData.brandname1
            this.brandData.desc1 = this.brandData.desc1
          if(value === 'editbname' || value === 'check')
            {
                if(this.brandData.brandname1==''){
                  this.hasErrors.brandnm1 ='Required';
                  this.submit_edi=1;
                }

                else if(this.brandData.brandname1.length > 100){
                  this.hasErrors.brandnm1 ='Maximum 100 characters';
                  this.submit_edi=1;
                }

                else if(this.brandData.brandname1.length < 2){
                  this.hasErrors.brandnm1  ='Minimum 2 characters';
                  this.submit_edi=1;
                }else{  this.hasErrors.brandnm1  ='';}
            }
            
          if(value === 'editbdesc' || value === 'check')
            {
                if(this.brandData.desc1.length > 500){
                  this.hasErrors.branddsc1 ='Maximum 500 characters';
                  this.submit_edi=1;
                }
                else if(this.brandData.desc1.length < 2){
                  this.hasErrors.branddsc1  ='Minimum 2 characters';
                  this.submit_edi=1;
                }else{  this.hasErrors.branddsc1  ='';}
            }
// end edit oncomplete
            }
        },
        computed:{
          brand_view: function(){
              if(this.$store.getters.get_brand_view === true){
                  this.shopuser('comp');
                  this.getTotals('comp');
                  this.is_admin = this.$store.getters.get_is_admin
                  return true
              }
              else{
                return false
              }
            },
            brand_rights: function(){
              return this.$store.getters.get_brand_rights
            }
        },
          created: function() {
            if(localStorage.authUser != null){
              this.access_token = '?access_token='+localStorage.authUser
            }
        //     var roles = JSON.parse(localStorage.getItem('roles'))
        //     // for (var i = 0; i < roles.length; i++) {
        //       if(roles[20].page_name == 21){
                
        //         this.pg_view = roles[20].view
        //         this.pg_rights = roles[20].rights
        //         if(this.pg_view){
        //           this.shopuser();
        //           this.getTotals();
        //         }
        //       }
        //     // }
        // }
        },
        
};
</script>



// WEBPACK FOOTER //
// src/views/setting/Brand.vue